import { CREATE_USER_ERROR, CREATE_USER } from "../constants/actionsTypes";
import * as api from "../api";

export const createUser = (userInfo) => async (dispatch) => {
  try {
    const user = await api.createUser(userInfo);
    console.log("success creating a user", user);

    dispatch({ type: CREATE_USER, response: user });
  } catch (error) {
    console.log("User creation error", error);
    dispatch({ type: CREATE_USER_ERROR, response: error });
  }
};

